import { useQuery } from "@tanstack/react-query";
import { api } from "jiffy-api";
import { objNamesToCamelCase, objNamesToSnakeCase } from "common/utils/helpers/cases";

export function useCartQuantity(assemblyGroupId?: string | null) {
  return useQuery({
    queryKey: ["cartQuantity", assemblyGroupId],
    queryFn: () => {
      const params = assemblyGroupId ? { assemblyGroupId } : undefined;
      return api.designLab.quantity(objNamesToSnakeCase(params)).then(objNamesToCamelCase);
    }
  });
}
